/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_Settings_FormInputs */

const en_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription settings form`)
};

const fr_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire des paramètres de transcription`)
};

const de_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formular für Transkriptionseinstellungen`)
};

const it_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo impostazioni trascrizione`)
};

const ru_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма настроек транскрипции`)
};

const es_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de configuración de transcripción`)
};

const zh_cn2_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录设置表单`)
};

const ja_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写設定フォーム`)
};

const hi_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन सेटिंग्स फॉर्म`)
};

const pt_pt2_transcription_settings_form = /** @type {(inputs: Transcription_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de configurações de transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription settings form" |
*
* @param {Transcription_Settings_FormInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_settings_form = /** @type {((inputs?: Transcription_Settings_FormInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_Settings_FormInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription_settings_form(inputs)
	if (locale === "de") return de_transcription_settings_form(inputs)
	if (locale === "it") return it_transcription_settings_form(inputs)
	if (locale === "ru") return ru_transcription_settings_form(inputs)
	if (locale === "es") return es_transcription_settings_form(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription_settings_form(inputs)
	if (locale === "ja") return ja_transcription_settings_form(inputs)
	if (locale === "hi") return hi_transcription_settings_form(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription_settings_form(inputs)
	return en_transcription_settings_form(inputs)
});